import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { ErrorResponse, ServerError } from './ErrorResponse';
export class InvoiceErrorResponse {
    // WHY: invoice status guards return an uncoded fmt.Sprintf message; delete once the backend returns a real AppErrorCode
    isStaleInvoiceStatus() {
        return this.error.hasErrorMessageIncluding('invalid invoice status');
    }
    unvoidMessage(invoice, texts) {
        return this.error.hasServerError(ServerError.InvoiceNotVoided) ? texts.invoice.unvoidNoLongerVoided({
            invoiceNumber: invoice.formattedNumber
        }) : texts.invoice.failedToUnvoid({
            invoiceNumber: invoice.formattedNumber
        });
    }
    unmarkPaidExternallyMessage(invoice, texts) {
        return this.error.hasServerError(ServerError.InvoiceNotPaidExternally) ? texts.invoice.unmarkPaidExternallyNoLonger({
            invoiceNumber: invoice.formattedNumber
        }) : texts.invoice.failedToUnmarkPaidExternally({
            invoiceNumber: invoice.formattedNumber
        });
    }
    constructor(error){
        _define_property(this, "error", void 0);
        this.error = error instanceof ErrorResponse ? error : new ErrorResponse(error);
    }
}
